import button from './components/button';
import headerImage from './components/headerImage';
import style from './components/style';
import footer from './components/footer';
import tinycolor from 'tinycolor2';

module.exports = {
  text: 'Double Points',
  value: 'double-points',
  subject: 'DOUBLE POINTS!!!',
  mjml(params) {
    const { brandingSettings: branding } = params;
    const slots = params.slots.map(({ content }) => ({
      content: content
        .replace(/{{[\s]*company\.name[\s]*}}/g, '{{defaults company.branding.name company.name "Referrals"}}'),
    }));

    return `<mjml>
      <mj-head>
        <mj-title>${params.subject}</mj-title>
        <mj-include path="../include/styles.mjml"/>
        <mj-attributes>
          <mj-class name="content" background-color="${branding.backgroundColour || '#ffffff'}" border-radius="4px"/>
        </mj-attributes>
        <mj-style>
          ${style(branding)}
        </mj-style>
      </mj-head>

      <mj-body
        width="760px"
        background-color="${branding.backgroundColour || '#ffffff'}"
      >
        ${!branding.hideBrandLogo ? `<mj-section>
          <mj-column>
            <mj-include path="../include/branding-logo.mjml"/>
          </mj-column>
        </mj-section> ` : ''}

        ${branding.headerImage ? headerImage(branding.headerImage) : ''}

        <mj-section mj-class="content">
          <mj-column>
            <mj-text color="${branding.secondaryColour || '#333333'}">
              <div class="text-content">${slots[0].content}</div>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section
          padding="44px 16px"
          background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
        >
          <mj-column padding-bottom="20px">
            <mj-text align="center">
              <h1>${slots[1].content}</h1>
            </mj-text>
          </mj-column>
          ${slots[2] && slots[2].content ? `<mj-column>${button(slots[2].content, branding)}</mj-column>` : ''}
        </mj-section>

        ${footer(branding)}

        <mj-include path="../include/footer-disclaimer.mjml"/>
      </mj-body>
    </mjml>`;
  },
  slots: [
    {
      name: 'Main Content',
      type: 'html',
      defaultContent: `
        <h1>DOUBLE POINTS!!!</h1>
        <h2>For the next 24 hours you get double points for every action you take on the Real Links platform.</h2>
        <p>Refer or introduce connections for open roles or share company content. It's double bubble on everything for
        the next 24 hours helping you move up the leaderboard and access the best rewards faster!</p>
      `,
    },
    {
      name: 'Footer Text',
      type: 'input',
      defaultContent: 'Quick... Time is running out!',
    },
    {
      name: 'Button Text',
      type: 'input',
      defaultContent: 'Introduce Us!',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/emails/double-points.js